import { Skeleton, Stack, useTheme } from "@mui/material";
import TextRow from "./TextRow";

const RepresentativeSkeleton = () => {
  const customTheme = useTheme();
  return (
    <>
      {[...Array(2)].map((_, index) => (
        <Stack
          direction={customTheme.alignment.direction.row}
          spacing={customTheme.dimensions.dimen5}
          alignItems={customTheme.alignment.alignItems.center}
          width={customTheme.dimensions.percent.dimen100}
          key={index}
          sx={(theme) => ({
            padding: theme.dimensions.dimen16,
            border: `1px solid ${theme.border.borderColour.borderE0E3E1}`,
          })}
        >
          <Stack width={customTheme.dimensions.percent.dimen8}>
            <Skeleton
              variant={customTheme.skeleton.variant.variantCircular}
              height={customTheme.dimensions.dimen56}
            />
          </Stack>

          <TextRow
            width={customTheme.dimensions.percent.dimen100}
            height={customTheme.dimensions.dimen10}
            rows={2}
          />
        </Stack>
      ))}
    </>
  );
};
export default RepresentativeSkeleton;
